



















export default {
  name: 'Graph',
  data: () => ({
    values: [
      {
        name: 'Skraper v1.0',
        data: {
          '2019-10-10': 100,
          '2019-10-11': 98,
          '2019-10-12': 94,
          '2019-10-13': 90,
          '2019-10-14': 80,
          '2019-10-15': 72,
          '2019-10-16': 65,
          '2019-10-17': 60,
          '2019-10-18': 48,
          '2019-10-19': 37,
          '2019-10-20': 35,
          '2019-10-21': 32,
          '2019-10-22': 30,
          '2019-10-23': 27,
          '2019-10-24': 25,
        },
      },
      {
        name: 'Skraper v1.2',
        data: {
          '2019-10-10': 10,
          '2019-10-11': 15,
          '2019-10-12': 30,
          '2019-10-13': 38,
          '2019-10-14': 45,
          '2019-10-15': 56,
          '2019-10-16': 69,
          '2019-10-17': 76,
          '2019-10-18': 84,
          '2019-10-19': 89,
          '2019-10-20': 92,
          '2019-10-21': 99,
          '2019-10-22': 104,
          '2019-10-23': 129,
          '2019-10-24': 118,
        },
      },
    ],
  }),
};
